import { getRuntimeTimezone } from '../../i18n/preferences';

export function requestToday(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: getRuntimeTimezone(), year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(now);
  const value = (type: Intl.DateTimeFormatPartTypes) => parts.find((part) => part.type === type)!.value;
  return `${value('year')}-${value('month')}-${value('day')}`;
}

export function currentRequestDates(
  dates: { pickupNotBefore: string; deliveryNotAfter: string },
  today = requestToday(),
) {
  const pickupNotBefore = dates.pickupNotBefore && dates.pickupNotBefore >= today
    ? dates.pickupNotBefore : today;
  const deliveryNotAfter = dates.deliveryNotAfter && dates.deliveryNotAfter >= pickupNotBefore
    ? dates.deliveryNotAfter : pickupNotBefore;
  return { pickupNotBefore, deliveryNotAfter };
}
